import * as React from 'react';
import { Card, Radio, Spin, Icon } from 'antd';
import '../../css/Dashboard.scss';
import { BarChart } from './Chart';
// import 'dragscroll';
import ScrollBooster from 'scrollbooster';
import debounce from 'lodash.debounce';
import * as d3 from 'd3';

interface BarChartProps {
    data: any;
    index: number;
    type?: string;
    title: string;
    xlabels: any;
    colors: any;
    legend: any;
    metric: string;
    handleMetricChange: any;
    loadNextContent: any;
    time: number;
    duration: number;
    dateRange: any;
}

interface BarChartState {
    data: any;
    xlabels: any;
    metric: any;
    hasMoreToLeft: boolean;
    hasMoreToRight: boolean;
    loading: boolean;
    isMouseDown: boolean;
}

export default class ChartContainer extends React.Component<BarChartProps, BarChartState> {
    chartDiv: any;
    scrollEnd: string;
    scrollWidth: number; // to hold ex-width of svg when scrollEnd is left
    counter: number = 1;

    constructor(props: any) {
        super(props);
        this.state = {
            data: [],
            xlabels: [],
            metric: 'day',
            hasMoreToLeft: true,
            hasMoreToRight: true,
            loading: false,
            isMouseDown: false,
        };
    }

    componentWillMount() {
        if (this.props.data !== undefined) {
            let hasMoreToLeft = true;
            let hasMoreToRight = true;
            this.scrollEnd = 'right';
            if (this.props.data.length < 20) {
                hasMoreToLeft = false;
            }
            this.setState(
                {
                    data: this.props.data,
                    xlabels: this.props.xlabels,
                    metric: this.props.metric,
                    hasMoreToLeft,
                    hasMoreToRight,
                    loading: false
                },
                () => {
                    if (this.props.data.length > 0) {
                        this.plotChart();
                        this.adjustScroll();
                    } else {
                        let chartDiv = d3.select(this.chartDiv);
                        chartDiv.select('.chart').html('');
                    }
                }
            );
        }
    }

    componentWillReceiveProps(nextProps: any) {
        if (nextProps.data !== this.props.data) {
            let hasMoreToLeft = this.state.hasMoreToLeft;
            let hasMoreToRight = this.state.hasMoreToRight;
            if (nextProps.data.length === 0) {
                hasMoreToLeft = false;
                hasMoreToRight = false;
            } else if (nextProps.time !== this.props.time) {
                hasMoreToLeft = true;
                hasMoreToRight = true;
                this.scrollEnd = 'right';
                if (nextProps.data.length < 20) {
                    hasMoreToLeft = false;
                }
            } else if (this.props.data) {
                let diff = nextProps.data.length - this.props.data.length;
                if (diff < 20) {
                    if (this.scrollEnd === 'left') {
                        hasMoreToLeft = false;
                    } else if (this.scrollEnd === 'right') {
                        hasMoreToRight = false;
                    }
                }
            }
            this.setState(
                {
                    data: nextProps.data,
                    xlabels: nextProps.xlabels,
                    hasMoreToLeft,
                    hasMoreToRight,
                    metric: nextProps.metric,
                    loading: false
                },
                () => {
                    if (nextProps.data.length > 0) {
                        this.plotChart();
                        this.adjustScroll();
                    } else {
                        let chartDiv = d3.select(this.chartDiv);
                        chartDiv.select('.chart').html('');
                    }
                }
            );
        }
    }

    adjustScroll() {
        if (this.scrollEnd === 'left') {
            this.chartDiv.scrollLeft = this.chartDiv.scrollWidth - this.scrollWidth;
        } else if (this.scrollEnd === 'right') {
            this.chartDiv.scrollLeft = this.chartDiv.scrollWidth - this.chartDiv.offsetWidth - 15;
        }
    }

    componentDidMount() {
        this.chartDiv = document.querySelectorAll('.chartDiv')[this.props.index];
        this.chartDiv.onscroll = debounce(() => this.debounceCallback(), 200);
        // this.plotChart();
        this.chartDiv.scrollLeft = this.chartDiv.scrollWidth - this.chartDiv.offsetWidth - 15;
        this.scrollWidth = this.chartDiv.scrollWidth;
        let viewport = this.chartDiv;
        let content = viewport.querySelector('svg');
        console.log(content);
        let sb = new ScrollBooster({
            viewport, // this parameter is required
            content, // scrollable element
            mode: 'x', // scroll only in horizontal dimension
            onUpdate: (data) => {
                // your scroll logic goes here
                viewport.scrollLeft = data.position.x;
            }
        });
        console.log('scroll booster', sb);
        if (this.props.legend.length) {
            this.plotLegend();
        }
    }

    debounceCallback = () => {
        let chartDiv = this.chartDiv;
        // Checks that the page has scrolled to the end
        if (chartDiv.scrollLeft <= 0) {
            if (!this.state.hasMoreToLeft) {
                this.setState({});
                return;
            }
            this.scrollWidth = chartDiv.scrollWidth;
            this.scrollEnd = 'left';
            this.setState(
                { loading: true },
                () => this.props.loadNextContent(this.props.index, this.state.metric, 'desc')
            );
        } else if (
            chartDiv.offsetWidth + chartDiv.scrollLeft >= chartDiv.scrollWidth
        ) {
            if (!this.state.hasMoreToRight) {
                this.setState({});
                return;
            }
            this.scrollEnd = 'right';
            this.setState(
                { loading: true },
                () => this.props.loadNextContent(this.props.index, this.state.metric, 'asc')
            );
        } else {
            this.setState({});
        }
    }

    handleMetricChange = e => {
        let metric = e.target.value;
        this.setState(
            { metric },
            () => this.props.handleMetricChange(metric, this.props.index)
        );
    }

    plotChart() {
        let chartDiv = d3.select(this.chartDiv);
        document.querySelectorAll('.chart')[this.props.index].innerHTML = '';
        let chart = new BarChart(
            chartDiv,
            350, // chart height
            this.state.data,
            this.state.xlabels,
            this.props.colors,
            this.props.type
        );
        console.log('plot chart', chart);
        // this.yaxis(chart);
    }

    yaxis(chart: any) {
        let svg: any = d3.select(document.querySelectorAll('.yaxis')[this.props.index]);
        let dmax = d3.max(
            this.props.data.map((d) => {
                if (Array.isArray(d)) {
                    return d.reduce((a, b) => a + b, 0);
                } else {
                    return d;
                }
            })
        );
        let yscale = d3.scaleLinear().domain([0, dmax]).range([0, 300]);
        let values: any = [];
        for (let i = 1; i < 10; i++) {
            values.push(Math.floor((dmax / 10) * i));
        }
        svg.selectAll('text')
            .data(values)
            .enter().append('text')
            .text((d) => d)
            .attr('x', 30)
            .attr('y', (d) => 260 - yscale(d))
            .attr('text-anchor', 'end');
    }

    plotLegend() {
        let legend = d3.selectAll('.legend').filter((d, i) => i === this.props.index);
        let offsets = this.props.legend.map(
            text => {
                let span: any = document.createElement('span');
                document.body.appendChild(span);
                span.style.width = 'auto';
                span.style.position = 'absolute';
                span.style.whiteSpace = 'no-wrap';
                span.innerHTML = text;
                let width = span.clientWidth;
                document.body.removeChild(span);
                return width;
            }
        );
        console.log('legend offsets', offsets);
        legend.selectAll('rect')
            .data(offsets)
            .enter().append('rect')
            .style('fill', (d, k) => this.props.colors[k])
            .attr('width', 15)
            .attr('height', 15)
            .attr('x', (d, k) => {
                if (k > 0) {
                    return offsets[k - 1] + 40;
                } else {
                    return 10;
                }
            })
            .attr('y', (d, k) => 0);

        legend.selectAll('text')
            .data(this.props.legend)
            .enter().append('text')
            .text((d) => d)
            .attr('x', (d, k) => {
                if (k > 0) {
                    return offsets[k - 1] + 60;
                } else {
                    return 30;
                }
            })
            .attr('y', (d, k) => 12);
    }

    handleMouseDown = (e, dir) => {
        this.setState({
            isMouseDown: true
        });
        if (dir === 'left') {
            let timer = setInterval(
                () => {
                    if (this.state.isMouseDown && this.chartDiv.scrollLeft > 0) {
                        this.chartDiv.scrollLeft -= (5 * this.counter);
                        this.counter++;
                    } else {
                        this.counter = 1;
                        clearInterval(timer);
                    }
                },
                100
            );
        } else {
            let timer = setInterval(
                () => {
                    if (this.state.isMouseDown &&
                        this.chartDiv.offsetWidth + this.chartDiv.scrollLeft < this.chartDiv.scrollWidth) {
                        this.chartDiv.scrollLeft += (5 * this.counter);
                        this.counter++;
                    } else {
                        this.counter = 1;
                        clearInterval(timer);
                    }
                },
                100
            );
        }
    }

    handleMouseUp = e => {
        this.setState({
            isMouseDown: false
        });
    }

    render() {
        let chartDiv = this.chartDiv;
        // let year1, year2;
        // if (this.props.dateRange[0] !== '') {
        //     year1 = new Date(this.props.dateRange[0]).getFullYear();
        //     year2 = new Date(this.props.dateRange[1]).getFullYear();
        // }
        return (
            <Card
                style={{ width: '46%', marginBottom: 24, textAlign: 'center' }}
                title={<div className="chartTitle">
                    <span>{this.props.title}</span>
                    <Radio.Group
                        onChange={this.handleMetricChange}
                        value={this.state.metric}
                    >
                        {this.props.duration < 120 && <Radio value="day">Day</Radio>}
                        {this.props.duration >= 30 && <Radio value="week">Week</Radio>}
                        {this.props.duration >= 60 && <Radio value="month">Month</Radio>}
                        {this.props.duration >= 365 && <Radio value="year">Year</Radio>}
                    </Radio.Group>
                </div>}
            >
                <Spin
                    spinning={this.state.loading}
                    tip="Loading..."
                    style={{ position: 'absolute', top: '50%' }}
                />
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    {
                        this.props.legend.length > 0 && <svg className="legend" />
                    }
                    <div style={{ display: 'flex' }}>
                        <div
                            style={{ display: 'flex', alignItems: 'center' }}
                            onMouseDown={e => this.handleMouseDown(e, 'left')}
                            onMouseUp={e => this.handleMouseUp(e)}
                        >
                            <Icon
                                type="caret-left"
                                style={{
                                    cursor: 'pointer',
                                    visibility: chartDiv !== undefined && chartDiv.scrollLeft > 0
                                        ? 'visible' : 'hidden'
                                }}
                            />
                        </div>
                        <div className="chartDiv">
                            <svg className="chart" />
                        </div>
                        <div
                            style={{ display: 'flex', alignItems: 'center' }}
                            onMouseDown={e => this.handleMouseDown(e, 'right')}
                            onMouseUp={e => this.handleMouseUp(e)}
                        >
                            <Icon
                                type="caret-right"
                                style={{
                                    cursor: 'pointer',
                                    visibility: chartDiv !== undefined &&
                                        (chartDiv.offsetWidth + chartDiv.scrollLeft) < chartDiv.scrollWidth
                                        ? 'visible' : 'hidden'
                                }}
                            />
                        </div>
                    </div>
                </div>
            </Card>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/chart/BarChart.tsx